import {useEffect, useState} from "react";
import {Routes, Route, useParams, Link} from "react-router-dom";
import Header from "../../layouts/Header";
import Icon from "../../components/icon";
import Listing from "./Listing";
import Edit from "./Edit";
import Create from "./Create";
import Fields from "./Fields";
import Segments from "./Segments";
import Segment from "./SegmentEdit";
import Entities from "./Entities";
import EntityManager from "./EntityManager";
import SegmentCreate from "./SegmentCreate";
import {UsePut} from "../../hooks/http";
import ConsentTypes from "./ConsentTypes";

const AudienceManager = () => {
    const {id, id2} = useParams()
    const [audience, setAudience] = useState()


    const GetAudienceData = async () => {
        const audienceRequest = await UsePut(
            `/audiences/get/${id}`,
            {data: {limit: 1, offset: 0, _id: id}}
        )
        return audienceRequest?.entities?.[0];
    }


    useEffect(() => {
        if(id){
            GetAudienceData().then(response => {
                setAudience(response)
            })
        }
    }, [id]);


    return (
        <>
            <Header
                icon="audience"
                title="Audience Manager"
                buttons={[
                    !id && window.location.pathname !== '/audiences/new' &&
                    <Link to={'new'} className="btn btn-sm btn-primary">
                        <Icon name="plus"/> <span>Create</span>
                    </Link>,
                ]}
            />
            <Routes>
                <Route index element={<Listing/>}/>
                <Route path="new" element={<Create/>}/>
                {audience && <>
                    <Route path=":id" element={<Edit audience={audience}/>}/>
                    <Route path=":id/fields" element={<Fields audience={audience}/>}/>
                    <Route path=":id/segments" element={<Segments audience={audience}/>}/>
                    <Route path=":id/segments/create" element={<SegmentCreate audience={audience} />}/>
                    <Route path=":id/segments/:id2" element={<Segment audience={audience} id_segment={id2}/>}/>
                    <Route path=":id/entities" element={<Entities audience={audience}/>}/>
                    <Route path=":id/entities/:id2" element={<EntityManager audience={audience}/>}>
                        <Route index element={<EntityManager audience={audience}/>}/>
                        <Route path="activity" element={<EntityManager audience={audience}/>}/>
                        <Route path="consents" element={<EntityManager audience={audience}/>}/>
                    </Route>
                    <Route path=":id/consent-types" element={<ConsentTypes audience={audience}/>}/>
                    <Route path=":id/robinson" element={<Entities robinson audience={audience}/>}/>
                </>}
            </Routes>
        </>
    )
}

export default AudienceManager
